import { useEffect } from "react";
import { useSelector } from "react-redux";
import * as Sentry from "@sentry/react";
import { RootState } from "store";

export function useSentryUserSession(): void {
  const { userToken, account } = useSelector((state: RootState) => state.authState);

  useEffect(() => {
    if (userToken && account) {
      Sentry.setUser({
        id: account.id,
        email: account.email
      });
      Sentry.setContext("session", {
        userToken,
        startedAt: new Date().toISOString()
      });
    } else {
      Sentry.setUser(null);
      Sentry.setContext("session", {});
    }
  }, [userToken, account]);
}
